import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Switch from 'components/Switch/Switch';
import Typography from 'components/Typography/Typography';

interface ScheduleStatusToggleProps {
  isActive: boolean;
  onToggle: (checked: boolean) => void;
  dataTestId?: string;
}

const ScheduleStatusToggle: React.FC<ScheduleStatusToggleProps> = ({
  isActive,
  onToggle,
  dataTestId
}) => {
  return (
    <div
      className={`flex items-center justify-between px-3 py-[11px] rounded-lg mb-5 ${isActive ? 'bg-green-50' : 'bg-base-muted'}`}
    >
      <div className="flex items-center gap-2">
        <FontAwesomeIcon
          icon={isActive ? 'fa-regular fa-lock-open' : 'fa-regular fa-lock'}
          className="w-4 h-4 text-base-foreground"
        />
        <Typography className="text-sm font-semibold text-base-foreground">
          {isActive ? 'Active' : 'Inactive'}
        </Typography>
        <Typography className={`text-sm text-base-sidebarForeground`}>
          |{' '}
          {isActive
            ? 'Deactivate to disable scheduled offers.'
            : 'Activate to enable scheduled offers.'}
        </Typography>
      </div>
      <Switch
        defaultChecked={isActive}
        onCheckedChange={onToggle}
        data-testid={dataTestId}
      />
    </div>
  );
};

export default ScheduleStatusToggle;
